import * as React from "react";
import { IBaseLink } from "~/types/link";
import FooterSocial, { ISocialLink } from "../footer-social/footer-social";

export interface IFooterListProps {
    links: IBaseLink[];
    socialLinks?: ISocialLink[];
}

const FooterListItem: React.SFC<IBaseLink> = (props, index: number) => {
    return (
        <li key={index} className="footer-list__item">
            <a className="footer-list__link" target={props.target} href={props.url}>
                {props.label}
            </a>
        </li>
    );
};

const FooterList: React.SFC<IFooterListProps> = props => {
    return (
        <>
            {props.links && <ul className="footer-list">{props.links.map(FooterListItem)}</ul>}
            {props.socialLinks && <ul className="footer-social">{props.socialLinks.map(FooterSocial)}</ul>}
        </>
    );
};

export default FooterList;
